import { render, staticRenderFns } from "./Telecredito.vue?vue&type=template&id=9443e07c"
import script from "./Telecredito.vue?vue&type=script&lang=ts"
export * from "./Telecredito.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports